import type { IconSvgObject } from './types';

const Office365Icon: IconSvgObject = [
  ["path", { d: "M4 18V6L14.5 2L20 4V20L14.5 22L4 18ZM4 18L14 18.5V6L8.5 7.5V15L4 18Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Office365Icon;
